import { NgModule } from '@angular/core';

import { APIS } from './api';

@NgModule({
  providers: [...APIS],
})
export class ApiModule {}
